import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import MenuIcon from "./Icons/menuIcon";

export default function MenuListComposition({
  jobId,
  onEdit,
  onDelete,
  onClose,
  onPause,
}) {
  const [open, setOpen] = React.useState(false);
  const [isPaused, setIsPaused] = React.useState(false);
  const anchorRef = React.useRef(null);

  React.useEffect(() => {
    const pausedState = localStorage.getItem("isPaused");
    if (pausedState === "true") {
      setIsPaused(true);
    }
  }, []);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      !event ||
      (anchorRef.current && !anchorRef.current.contains(event.target))
    ) {
      setOpen(false);
    }
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const handlePauseResumeClick = () => {
    setIsPaused((prevState) => {
      const newState = !prevState;
      localStorage.setItem("isPaused", newState.toString());

      onPause(newState);

      handleClose();
      return newState;
    });
  };

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          sx={{
            textTransform: "none",
            padding: 0,
            minWidth: "unset",
            margin: 0,
            background: "none",
            boxShadow: "none",
            "&:hover": {
              background: "none",
              boxShadow: "none",
              cursor: "pointer",
            },
          }}
        >
          <MenuIcon />
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="left-start"
          transition
          disablePortal
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: "right top",
              }}
            >
              <Paper
                sx={{
                  width: "145px",
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        onEdit();
                      }}
                    >
                      Edit
                    </MenuItem>
                    <hr className="text-border" />
                    <MenuItem onClick={handlePauseResumeClick}>
                      {isPaused ? "Resume Job" : "Pause Job"}
                    </MenuItem>
                    <hr className="text-border" />
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        onClose();
                      }}
                    >
                      Close
                    </MenuItem>
                    <hr className="text-border" />
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        onDelete();
                      }}
                    >
                      Delete
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
